import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBoT_mE2mhaJew6VW1WEsVkZDYR-jKX4Vc",
  authDomain: "rubiks-rank.firebaseapp.com",
  projectId: "rubiks-rank",
  storageBucket: "rubiks-rank.appspot.com",
  messagingSenderId: "264168555641",
  appId: "1:264168555641:web:8cf75154ab5463be7580a8",
};

firebase.initializeApp(firebaseConfig);
export default firebase;
export const db = firebase.firestore();
